import { createRouter, createWebHistory } from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import MainLayout from '@/layouts/Main'

// Diasumsikan role untuk pengguna non-verifikator adalah 'pasien'
const ROLE_PASIEN = 'patient'
const ROLE_VERIFICATOR = 'verificator'
const ROLE_PHARMACY = 'pharmacy'

const router = createRouter({
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      component: MainLayout,
      meta: {
        authRequired: true,
      },
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          meta: { title: 'Dashboard', roles: [ROLE_PASIEN] },
          component: () => import('./views/course'),
        },
        {
          path: '/notification',
          name: 'Notification',
          meta: { title: 'Notification', roles: [ROLE_PASIEN, ROLE_VERIFICATOR, ROLE_PHARMACY] },
          component: () => import('./views/notification'),
        },

        {
          path: '/profil',
          name: 'Profil Saya',
          meta: { title: 'Profil Saya', roles: [ROLE_PASIEN, ROLE_VERIFICATOR, ROLE_PHARMACY] },
          component: () => import('./views/profile'),
        },
        {
          path: '/forgot-password',
          name: 'Forgot Password',
          meta: { title: 'Forgot Password', roles: [ROLE_PASIEN, ROLE_VERIFICATOR, ROLE_PHARMACY] },
          component: () => import('./views/forgot-password'),
        },
        {
          path: '/program',
          name: 'Program',
          meta: { title: 'Program', roles: [ROLE_PASIEN] },
          component: () => import('./views/program'),
        },
        {
          path: '/programType',
          name: 'Program Type',
          meta: { title: 'Program Type', roles: [ROLE_PASIEN] },
          component: () => import('./views/programType'),
        },
        {
          path: '/unggahInvoice',
          name: 'Unggah Invoice',
          meta: { title: 'Program Type', roles: [ROLE_PASIEN] },
          component: () => import('./views/program/proses/unggahInvoice.vue'),
        },
        {
          path: '/mainProgram',
          name: 'Main Program',
          meta: { title: 'Main Program', roles: [ROLE_PASIEN] },
          component: () => import('./views/program/mainProgram.vue'),
        },
        {
          path: '/program/persetujuan',
          name: 'Program Persetujuan',
          meta: { title: 'Program Persetujuan', roles: [ROLE_PASIEN] },
          component: () => import('./views/program/proses/persetujuan.vue'),
        },
        {
          path: '/program/konfirmasi-dokter',
          name: 'Program Konfirmasi Dokter',
          meta: { title: 'Program Konfirmasi Dokter', roles: [ROLE_PASIEN] },
          component: () => import('./views/program/proses/konfirmasiDokter.vue'),
        },
        {
          path: '/program/unggah-resep-dokter',
          name: 'Program Unggah Resep Dokter',
          meta: { title: 'Program Unggah Resep Dokter', roles: [ROLE_PASIEN] },
          component: () => import('./views/program/proses/unggahResepDokter.vue'),
        },
        {
          path: '/program/hasil-tes-lab',
          name: 'Program Unggah Hasil Tes Lab',
          meta: { title: 'Program Unggah Hasil Tes Lab', roles: [ROLE_PASIEN] },
          component: () => import('./views/program/proses/UnggahHasilTes/index.vue'),
        },
        {
          path: '/program/unggah-hasil-tes',
          name: 'Program Unggah Hasil Tes',
          meta: { title: 'Program Unggah Hasil Tes', roles: [ROLE_PASIEN] },
          component: () => import('./views/program/proses/UnggahHasilTes/unggahTes.vue'),
        },
        {
          path: '/program/tes-list',
          name: 'Program Tes List',
          meta: { title: 'Program Tes List', roles: [ROLE_PASIEN] },
          component: () => import('./views/program/proses/UnggahHasilTes/tesList.vue'),
        },
        {
          path: '/survey',
          name: 'Survey',
          meta: { title: 'Survey', roles: [ROLE_PASIEN] },
          component: () => import('./views/program/proses/survey.vue'),
        },
        {
          path: '/unggah-asuransi',
          name: 'Unggah Asuransi',
          meta: { title: 'Unggah Asuransi', roles: [ROLE_PASIEN] },
          component: () => import('./views/program/proses/unggahAsuransi.vue'),
        },
        {
          path: '/scan',
          name: 'Main Scanner',
          meta: { title: 'Main Scanner', roles: [ROLE_PASIEN] },
          component: () => import('./views/scanner/index.vue'),
        },
        {
          path: '/scan/unggah-bukti',
          name: 'Scanner Upload',
          meta: { title: 'Scanner Upload', roles: [ROLE_PASIEN] },
          component: () => import('./views/scanner/unggahBukti.vue'),
        },
        {
          path: '/scheduling',
          name: 'Scheduling',
          meta: { title: 'Scheduling', roles: [ROLE_PASIEN] },
          component: () => import('./views/scheduling/index.vue'),
        },
        {
          path: '/injectionSchedule',
          name: 'Injection Schedule',
          meta: { title: 'Injection Schedule', roles: [ROLE_PASIEN] },
          component: () => import('./views/scheduling/injection.vue'),
        },
        {
          path: '/history',
          name: 'History',
          meta: { title: 'History', roles: [ROLE_PASIEN] },
          component: () => import('./views/scheduling/history.vue'),
        },
        {
          path: '/extending',
          name: 'Extending',
          meta: { title: 'Extending', roles: [ROLE_PASIEN] },
          component: () => import('./views/program/extending/extend.vue'),
        },
        {
          path: '/extending/stop',
          name: 'Extending Stop',
          meta: { title: 'Extending Stop', roles: [ROLE_PASIEN] },
          component: () => import('./views/program/extending/stop.vue'),
        },
        {
          path: '/extending/success',
          name: 'Extending Success',
          meta: { title: 'Extending Success', roles: [ROLE_PASIEN] },
          component: () => import('./views/program/extending/success.vue'),
        },
        {
          path: '/article',
          name: 'Artikel List',
          meta: { title: 'Artikel List', roles: [ROLE_PASIEN] },
          component: () => import('./views/article'),
        },
        {
          path: '/article/:id',
          name: 'Artikel Detail',
          meta: { title: 'Artikel Detail', roles: [ROLE_PASIEN] },
          component: () => import('./views/article/detail.vue'),
        },
        {
          path: '/bantuan',
          name: 'Bantuan',
          meta: { title: 'Bantuan', roles: [ROLE_PASIEN] },
          component: () => import('./views/bantuan'),
        },
        {
          path: '/video-article',
          name: 'Video Artikel',
          meta: { title: 'Video Artikel', roles: [ROLE_PASIEN] },
          component: () => import('./views/video'),
        },
        {
          path: '/farmasi',
          name: 'Pharmacy',
          meta: { title: 'Pharmacy', roles: [ROLE_PHARMACY] },
          component: () => import('./views/pharmacy/index.vue'),
        },
        {
          path: '/pasien-farmasi',
          name: 'Pasien Pharmacy',
          meta: { title: 'Pasien Pharmacy', roles: [ROLE_PHARMACY] },
          component: () => import('./views/pharmacy/pasien.vue'),
        },
        {
          path: '/riwayat-farmasi',
          name: 'Riwayat Farmasi',
          meta: { title: 'Riwayat Farmasi', roles: [ROLE_PHARMACY] },
          component: () => import('./views/pharmacy/riwayat.vue'),
        },
        {
          path: '/qr',
          name: 'QR',
          meta: { title: 'QR', roles: [ROLE_PHARMACY] },
          component: () => import('./views/pharmacy/qr.vue'),
        },
        // --- RUTE KHUSUS VERIFICATOR ---
        {
          path: '/verificator',
          name: 'Verificator',
          meta: { title: 'Verificator', roles: [ROLE_VERIFICATOR] },
          component: () => import('./views/verificator/index.vue'),
        },
        {
          path: '/dokter',
          name: 'Dokter',
          meta: { title: 'Dokter', roles: [ROLE_VERIFICATOR] },
          component: () => import('./views/verificator/dokter.vue'),
        },
        {
          path: '/farmasi',
          name: 'Farmasi',
          meta: { title: 'Farmasi', roles: [ROLE_VERIFICATOR] },
          component: () => import('./views/verificator/farmasi.vue'),
        },
        {
          path: '/pasien',
          name: 'Pasien',
          meta: { title: 'Pasien', roles: [ROLE_VERIFICATOR] },
          component: () => import('./views/verificator/pasien.vue'),
        },
        // {
        //   path: '/transaksi',
        //   name: 'Transaksi',
        //   meta: { title: 'Transaksi', roles: [ROLE_VERIFICATOR] },
        //   component: () => import('./views/verificator/transaksi.vue'),
        // },
      ],
    },

    // --- HALAMAN PUBLIK / SISTEM ---
    {
      path: '/auth',
      component: AuthLayout,
      meta: { authRequired: false },
      name: 'auth',
      children: [
        {
          path: 'login',
          name: 'masuk',
          meta: { title: 'Masuk' },
          component: () => import('./views/auth/login'),
        },
        {
          path: 'login-verificator',
          name: 'masuk verificator',
          meta: { title: 'Masuk Verificator' },
          component: () => import('./views/verificator/login'),
        },
        {
          path: 'login-pharmacy',
          name: 'masuk pharmacy',
          meta: { title: 'Masuk Pharmacy' },
          component: () => import('./views/pharmacy/login'),
        },
        {
          path: 'register',
          name: 'register',
          meta: {
            title: 'Sign Up',
          },
          component: () => import('./views/auth/register'),
        },
        {
          path: 'forgot-password',
          name: 'Lupa Password',
          meta: {
            title: 'Lupa Password',
          },
          component: () => import('./views/auth/forgot-password'),
        },
        {
          path: 'forgot-password-verificator',
          name: 'Lupa Password Verificator',
          meta: {
            title: 'Lupa Password Verificator',
          },
          component: () => import('./views/auth/forgot-password-verificator'),
        },
        {
          path: 'forgot-password-pharmacy',
          name: 'Lupa Password Pharmacy',
          meta: {
            title: 'Lupa Password Pharmacy',
          },
          component: () => import('./views/auth/forgot-password-pharmacy'),
        },
        {
          path: 'lockscreen',
          meta: {
            title: 'Lockscreen',
          },
          component: () => import('./views/auth/lockscreen'),
        },
      ],
    },
    {
      path: '/404',
      name: 'route404',
      meta: { title: 'Error 404' },
      component: () => import('./views/auth/404'),
    },
    {
      path: '/500',
      meta: { title: 'Error 500' },
      component: () => import('./views/auth/500'),
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'route404' },
    },
  ],
})

// --- PENGAWAL NAVIGASI (NAVIGATION GUARD) ---
router.beforeEach((to, from, next) => {
  const storedAccessToken = localStorage.getItem('accessToken')

  if (to.matched.some(record => record.meta.authRequired)) {
    if (!storedAccessToken) {
      return next({ name: 'masuk' }) // Alihkan ke halaman login
    }

    const requiredRoles = to.meta.roles
    const storedUserData = localStorage.getItem('userData')
    let userRole = null

    try {
      const userData = JSON.parse(storedUserData || '{}')
      userRole = userData.user?.role
      console.log('userRole:', userRole, requiredRoles)
    } catch (e) {
      console.error('Gagal parse userData, membersihkan session:', e)
      localStorage.clear()
      return next({ name: 'masuk' })
    }

    // Jika karena suatu hal role user tidak ditemukan, lempar ke login
    if (!userRole) {
      localStorage.clear()
      return next({ name: 'masuk' })
    }

    // --- LOGIKA UTAMA UNTUK USER YANG SUDAH LOGIN ---

    // SKENARIO A: User adalah 'verificator'
    if (userRole === ROLE_VERIFICATOR) {
      // Verifikator hanya boleh akses halaman yang memiliki role 'verificator'
      if (requiredRoles && requiredRoles.includes(ROLE_VERIFICATOR)) {
        next() // Izinkan akses
      } else {
        // Jika mencoba akses halaman lain, alihkan ke halaman utama verifikator
        if (to.name !== 'Verificator') {
          next({ name: 'Verificator' })
        } else {
          next()
        }
      }
    }
    // SKENARIO B: User adalah role lain (misalnya 'pasien')
    else {
      // Jika route membutuhkan role, cek apakah role user cocok
      if (requiredRoles && requiredRoles.length > 0) {
        if (requiredRoles.includes(userRole)) {
          next() // Izinkan, karena role-nya cocok (misal: pasien akses dashboard)
        } else {
          console.log('masuk 1')
          next({ name: 'Dashboard' }) // Alihkan ke dashboard mereka
        }
      } else {
        // Jika route tidak punya metadata 'roles' sama sekali
        // Sebaiknya alihkan ke halaman utama untuk mencegah akses ke halaman yang tidak terdefinisi
        console.log('masuk 2')

        next({ name: 'Dashboard' })
      }
    }
  } else {
    // Jika route tidak butuh otentikasi (misal: halaman login), langsung izinkan
    next()
  }
})

export default router
